// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import Home from "Home"
import Action from "modules/action"
import Dashboard from "Dashboard"
import User from "Dashboard/user"
import Prgm from 'Dashboard/program'
import Notify from 'modules/notify'
import Pmdsl from 'Dashboard/pmdsl'
import EchoDesk from 'Dashboard/echodesk'
import Department from 'Department'
import Aiva from 'Aiva'
import DigitalSig from 'Digitalsig'
import Producer from 'Producer'
import DeviceProducer from 'DeviceProducer'

Rails.start()
Turbolinks.start()
ActiveStorage.start()

window.Action = new Action();
window.Dashboard = new Dashboard();
window.User = new User();
window.Prgm = new Prgm();
window.Notify = new Notify();
window.Pmdsl = new Pmdsl();
window.EchoDesk = new EchoDesk();
window.Department = new Department();
window.Aiva = new Aiva();
window.DigitalSig = new DigitalSig();
window.Producer = new Producer();
window.DeviceProducer = new DeviceProducer();

window.onload = () => {
  new Home();
}
